import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import AuthService from './lib/AuthService'

// what is the URI of the GraphQl server?
const GRAPHQL_URI = process.env.VUE_APP_GRAPHQL_URI

// HTTP connexion to the API
const httpLink = new HttpLink({
  uri: GRAPHQL_URI
})

// Auth Middleware
const authMiddleware = setContext(async (operation, { headers }) => {
  // get the auth headers
  const authHeaders = await AuthService.generateAuthHeaders()
  // return the combined headers
  return {
    headers: {
      ...headers,
      ...authHeaders
    }
  }
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authMiddleware.concat(httpLink),
  cache
})

// add plugin to Vue
Vue.use(VueApollo)

// create the apollo client instance
export const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
